export default {
  sale: {
    title: 'Dear',
    subtitle: 'Fill the form and click Confirm.',
    amount: 'Amount',
    linkExpirationDate: 'Valid until',
    cardNumber: 'Card Number',
    securityCode: 'CVC',
    dueDate: 'Expiration',
    brand: 'Label',
    installments: 'Number of Payments',
    file: 'File',
    holder: 'Holder',
    holderName: 'Name of Holder',
    inscription: 'Inscription',
    birthDate: 'Birth date',
    email: 'Email',
    phone: 'Phone',
    zipCode: 'Zip Code',
    zipCodeMask: '',
    country: 'Country',
    state: 'State',
    uf: 'UF',
    city: 'City',
    district: 'District',
    address: 'Address',
    number: 'Number',
    complement: 'Complement',
    brandIsMandatory: 'Label is required!',
    rejectedByAntifraud: 'Card accepted by anti-fraud',
    paymentConfirmed: 'Payment confirmed successfully!',
    reviewingPayment: 'Payment under review!',
    reviewingPreAuthorization: 'Pre-authorization under review!',
    preAuthorizationConfirmed: 'Pre-authorization successful!',
    paymentNotConfirmed: 'Unauthorized payment!',
    paymentAborted: 'Transaction denied!',
    paymentNotMadeTryLater: 'Could not wait for payment! Please try again later or contact us!',
    integrationError: 'Payment not processed: There was an error with external credit card service',
    unknownError: 'Payment not processed: There was an unidentified error.',
    confirm: 'Confirm',
    loading: 'Loading...',
    datePlaceholder: 'dd/mm/yyyy',
    terms: 'I agree with the ',
    termsLink: 'general conditions',
    generalConditions: '<style>.subject {	color: #666;} .text { color: #777; }</style><span class="subject bold">Travel contract</span><br />'+
      '<span class="topic bold">1) THE PARTIES</span><br />'+
      '<span class="text">'+
      '	1.1 CLIENT, already stated above as CONTRACTOR.<br />'+
      '	1.2 {companyName}, located at {companyAddress} from now on referred to only as'+
      '	OPERATOR.<br />'+
      '</span>'+
      '<br />'+
      '<span class="topic bold">2) LEGAL BASIS OF THE CONTRACT.</span><br />'+
      '<span class="text">'+
      '	This contract has been developed in light of the Consumer Defense Code, the Brazilian Aeronautical Code, including'+
      '	resolution number 400/2016, and the Warsaw Convention Decree Nº 5.406 FROM THE 30TH OF MARCH 2005, as well as other'+
      '	legislations and deliberations relevant to the matter, according to the text recommended by the Brazilian Association'+
      '	of Tourist Operators - BRAZTOA.<br />'+
      '</span>'+
      '<br />'+
      '<span class="topic bold">3) RESPONSIBILITY OF THE OPERATOR:</span><br />'+
      '<span class="text">'+
      '	3.1 The operator functions as an intermediary between the client and the service providers, such as: air and maritime'+
      '	travel companies, hotels, incoming companies and others relating to the itineraries.<br />'+
      '	3.2 Due to technical-operational reasons, if any force majeure or fortuitous situations arise which prevent complete'+
      '	or partial fulfilment of the sold journey, the operator can promote changes, if necessary, modifying itineraries,'+
      '	dates, schedules, services, periods and others, not becoming obliged to reimburse the fees paid.<br />'+
      '	3.3 The operator may change, substitute or transfer airline companies, the type of vehicles and/or aircrafts,'+
      '	chartered or regular, as well as boarding and landing locations in airports, without being obliged to provide'+
      '	information on any possible stopovers and connections during the journey, as these are scheduled by the transportation'+
      '	companies themselves.<br />'+
      '</span>'+
      '<br />'+
      '<span class="topic bold">4) RESPONSIBILITY OF THE CLIENT:</span><br />'+
      '<span class="text">'+
      '	4.1 The client is responsible for the payment of the sold trip, to be paid in full before the departure date.<br />'+
      '	4.2 Customs taxes, laundry services, drinks, telephone calls, tips, optional tours, extra meals, extra coffee, fees'+
      '	and tickets for parks, museums, churches, shows and any other expenses not covered by the contract are the'+
      '	responsibility of the client.<br />'+
      '	4.3 The client should observe and obey the transportation companies’ pre-determined time schedules, adhere to the'+
      '	behaviour and security conditions stipulated by these companies, as well as the internal procedure norms of the'+
      '	contracted service providers’ establishments.<br />'+
      '	4.4 The client is subject to restrictions on the weight and quantity of luggage as established by the transportation'+
      '	companies, and is responsible for its safekeeping and conservation during in/out transfers, accounting for any'+
      '	possible damage caused by negligence and/or imprudence.<br />'+
      '	4.5 In the case of force majeure or fortuitous situations, such as flight or boat delays or cancelations, technical,'+
      '	mechanical or meteorological problems, airport closures, highway closures, governmental decisions, interdictions'+
      '	derived from public authorities, strikes, wars, natural phenomena and others, prolonging, reducing or cancelling the'+
      '	trip, all additional expenses are the responsibility of the client, excusing the operator and travel agencies of'+
      '	responsibility and of obligation to issue payments or refunds of total or partial amounts.<br />'+
      '	4.6 Personal documents necessary for national and international journeys are the responsibility of the client, who'+
      '	should follow the demands and guidelines of local authorities, such as original identity card (including minors),'+
      '	passport with valid entry visa for the destination countries, and any other possible requirements.<br />'+
      '	4.7 For minors of 12 years or under travelling domestically, and for minors of 18 years or under travelling'+
      '	internationally, who are unaccompanied by parents or guardians, besides the above mentioned documents, an'+
      '	authorization from the Children and Adolescents’ Court is also required<br />'+
      '</span>'+
      '<br />'+
      '<span class="topic bold">5) REFUNDS AND PENALITIES REGARDING CANCELATIONS:</span><br />'+
      '<br />'+
      '<span class="text">'+
      '	5.1 AIR TRAVEL<br />'+
      '	<br />'+
      '	Cancelation requests and refunds regarding airline tickets will be sent to the relevant airline companies and will be'+
      '	subject to the penalties and terms already established by said companies, with which the operator has no involvement.'+
      '	Note: All cancelations and transfers are rigorously limited to conditions already agreed upon between the operator and'+
      '	the transport company, which in turn, observe relevant and valid legislation.<br />'+
      '	<br />'+
      '	5.2 LAND SERVICES.<br />'+
      '	<br />'+
      '	In the case of any requests to cancel land travel reservations, no refund will be issued by the operator, unless'+
      '	otherwise informed upon booking confirmation.<br />'+
      '	<br />'+
      '	5.3 Any client who does not turn up for boarding, abandons or forgoes the trip after it has begun, during its'+
      '	execution, or unilaterally changes the conditions already agreed upon, will take responsibility for all following'+
      '	expenses that occur, making the operator and the service providers free of all liability to grant refunds or'+
      '	compensations for services not used or substituted, also implying total loss of the amount agreed upon.<br />'+
      '</span>'+
      '<br />'+
      '<span class="topic bold">6) FINAL CONSIDERATIONS:</span><br />'+
      '<span class="text">'+
      '	6.1 For all legal purposes, the client declares having read, understood, agreed and accepted all the above related'+
      '	items. In case of any doubts contact the agency or operator.<br />'+
      '</span>',
  },
  home: {
    loadingSale: 'Loading charge',
    tryAgain: 'Try again',
  },
};



// WEBPACK FOOTER //
// ./src/assets/translationEn.js